<template>
  <div class="filter" @click="onClick">
    <span class="filter-text">絞り込み</span>
    <span v-if="filterCount > 0" class="filter-count">{{ filterCount }}</span>
  </div>
</template>
<script>
export default {
  props: {
    filterCount: {
      type: Number,
      required: false,
      default: 0
    }
  },
  methods: {
    onClick() {
      this.$emit('clicked')
    }
  }
}
</script>
<style lang="scss" scoped>
.filter {
  background-color: $white;
  border: 1px solid $gray-2;
  border-radius: 4px;
  padding: 16px;
  cursor: pointer;
  line-height: 1.6;
  text-align: justify;
  display: flex;
  gap: 8px;
  height: 52px;
  box-sizing: border-box;

  &-text {
    font-size: 1.2rem;
    line-height: 1.6;
    height: 20px;
    padding: 1px 0;
  }

  &-count {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: $black;
    color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
